// @flow

import * as React from 'react';
import SearchSort from '../../components/SearchSort';
import formatUrlCriteria from 'utils/formatUrlCriteria';
import staticRedirect from 'utils/staticRedirect';
import extractUrlCriteria from 'utils/extractUrlCriteria';

import type { UrlCriteria } from 'utils/_types';

const SearchSortElement = (): React.Node => {
    const criteria: UrlCriteria = extractUrlCriteria(window.location.href);

    const searchHandler = React.useCallback((value: string) => {
        const [sortType, sortDirection] = value.split(':');

        const searchPath = formatUrlCriteria({ ...criteria, sortType, sortDirection });

        // $FlowFixMe Turbolinks est chargé à l'extérieur
        if (Turbolinks) { // eslint-disable-line no-undef
            Turbolinks.visit(searchPath); // eslint-disable-line no-undef
        } else {
            staticRedirect(searchPath);
        }
    }, [criteria]);

    return (
        <SearchSort
            criteria={criteria}
            onSearch={searchHandler}
        />
    );
};

export default SearchSortElement;
